import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { MenuItem } from 'react-bootstrap/lib';
import withDealerPermission from './dealerPermission';

function CancelButton({ dealer, onCancel }) {
  return <MenuItem onClick={() => onCancel(dealer)}>Cancel Tests</MenuItem>;
}

CancelButton.propTypes = {
  dealer: PropTypes.object,
  onCancel: PropTypes.func,
};

export default withDealerPermission(Permissions.CREATE)(CancelButton);
